import Chip from '@material-ui/core/Chip';
import { isReverse } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import { sanlamGrey, sanlamYellow } from 'Material-UI/colors';
import React from 'react';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import styled from 'styled-components';

const StyledChip = styled(({ matches, status, isLongLabel, ...otherProps }) => (
  <Chip {...otherProps} />
))`
  && {
    padding: 0px 5px;
    direction: ${(props) => (props.reverse ? 'ltr' : 'rtl')};
    text-align: ${(props) => (props.reverse ? 'right' : 'left')};
    font-size: 10px;
    font-weight: bold;
    border-radius: 12px;
    max-width: 130px;
    min-height: ${(props) => (props.isLongLabel ? '50px' : '0')};
    & .MuiChip-label {
      white-space: normal;
    }
    > img {
      height: ${(matches) => (matches ? '10px' : '11px')};
      width: ${(matches) => (matches ? '9px' : '11px')};
      margin-left: ${(matches) => (matches ? '1px' : '4px')};
      margin-right: ${(matches) => (matches ? '1px' : '4px')};
    }
    color: ${(props: any) => {
      switch (props.status) {
        case 'success':
          return '#6FAD37';
        case 'cancel':
        case 'warning':
          return '#172C51';
        case 'error':
          return '#D0021B';
        default:
          return '#172C51';
      }
    }};
    border: 1px solid
      ${(props: any) => {
        switch (props.status) {
          case 'success':
            return '#6FAD37';
          case 'warning':
            return sanlamYellow;
          case 'error':
            return '#D0021B';
          default:
            return '#172C51';
        }
      }};

    background-color: ${(props: any) => {
      switch (props.status) {
        case 'success':
          return '#E3EFD7';
        case 'warning':
          return '#FEF1D1';
        case 'error':
          return '#F6CDD1';
        case 'cancel':
          return sanlamGrey;
        default:
          return '#c2c2c2';
      }
    }};
  }
`;

const selectIcon = (status: string) => {
  switch (status) {
    case 'success':
      return get(AssuranceIcon, 'checkCircle');
    case 'warning':
      return get(AssuranceIcon, 'clock');
    case 'cancel':
      return get(AssuranceIcon, 'xGreyCircle');
    case 'error':
      return get(AssuranceIcon, 'xCircle');
    default:
      return get(AssuranceIcon, 'clock');
  }
};

const StatusChip = (props: any) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <StyledChip
      size={props.label === "Complément d'information" ? 'medium' : 'small'}
      {...props}
      reverse={reverse}
      avatar={<img src={selectIcon(props.status)} alt="item-icon" />}
    />
  );
};

export default StatusChip;
